import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsError from "glesys-controlpanel/components/icons/error";
import { t } from "ember-intl";

<template>
  <div
    class="flex flex-col items-center justify-center h-full"
    data-test-route-error-default
    {{mergeClasses}}
    ...attributes
  >
    <IconsError class="w-20 h-20" />
    <h1 class="text-xl text-gray-800 pt-4">
      {{t "component.route-error.default"}}
    </h1>
  </div>
</template>
